/**
 * Website visit beacon for the public pages (GID-Session-022). The server side
 * is server/services/visits.js; the landing site carries its own copy of this
 * in a <script> because it is a separate static site.
 *
 * The ?src= tag (fb-launch, qr, drop-serafina, site) is kept for the tab's
 * session, so the booking made three steps later is credited to where the
 * visitor came from. No cookie, nothing stored on the server that names them.
 */
const SRC_KEY = 'gid_src';

function readSrc() {
  let src = null;
  try {
    src = new URLSearchParams(window.location.search).get('src');
    if (src) sessionStorage.setItem(SRC_KEY, src);
    else src = sessionStorage.getItem(SRC_KEY);
  } catch { /* storage blocked — the URL is all we have */ }
  return src;
}

export function sendVisit({ site = 'book', event = 'view' } = {}) {
  if (navigator.webdriver) return; // test suites and automation, not people
  const body = JSON.stringify({
    site,
    event,
    path: window.location.pathname,
    src: readSrc(),
    ref: document.referrer || null
  });
  try {
    if (navigator.sendBeacon?.('/api/public/visit', new Blob([body], { type: 'text/plain' }))) return;
  } catch { /* fall through */ }
  fetch('/api/public/visit', { method: 'POST', body, headers: { 'Content-Type': 'text/plain' }, keepalive: true, credentials: 'include' }).catch(() => {});
}
